interface TrackPopupViewEventPropsI {
	category: string;
	name: string;
}

declare global {
	interface Window {
		dataLayer?: object[];
	}
}

export function trackPopupViewEvent({
	category,
	name,
}: TrackPopupViewEventPropsI) {
	window.dataLayer = window.dataLayer || [];
	
	window.dataLayer.push({
		event: "modal_view",
		model_name: name,
		model_category: category,
	});
}

export const prepareProductItem = (item) => {
	const categoriesObject = item.navigationPath
		.split("/")
		?.reduce((acc, curr, index) => {
			acc[`item_category${index > 0 ? index + 1 : ""}`] = curr;
			return acc;
		}, {});

	const discount = item.promotionPrice
		? item.priceNet - item.promotionPrice
		: 0;

	return {
		index: item.index,
		item_name: item.productName,
		item_id: item.productId,
		quantity: item.quantity || 1,
		price: item.priceNet,
		discount,

		item_division_id: item.divisionId,
		item_division_name: item.divisionName,
		item_group_id: item.groupId,
		item_group_name: item.groupName,
		item_subgroup_id: item.subGroupId,
		item_subgroup_name: item.subGroupName,
		item_manufacturer_number: item.manufacturerPartNumber,

		item_brand: item.manufacturer,
		item_reviews: item.countOfReviews || 0,
		item_rating: item.averageRating || 0,

		item_stock_status: item.stockStatus,
		item_bundle: !!item.isConfigBndle,
		item_leasable: !!item.subscription,
		item_list_id: item?.item_list_id || "",
		item_list_name: item?.item_list_name || "",
		...categoriesObject,
	};
};

export function prepareInsuranceItem(item) {
	const name = item.name.includes(" - ")
		? item.name.split(" - ")[0]
		: item.name;

	return {
		item_name: name,
		item_id: item.id,
		price: item.price,

		item_division_id: 0,
		item_division_name: "General",
		item_group_id: 95,
		item_group_name: "Insurance",

		item_brand: "Komplett",
		item_stock_status: "digital",

		item_category: "Services",
		item_category2: "Insurance",
		item_category3: item.variant,
	};
}

function pushCartEvent(
	event: "add_to_cart" | "remove_from_cart",
	item,
	app?: string,
) {
	window.dataLayer = window.dataLayer || [];

	window.dataLayer.push({
		event,
		...(app && { app }),
		ecommerce: {
			items: [item],
		},
		_clear: true,
	});
}

export function insuranceAdded(insurance) {
	pushCartEvent("add_to_cart", insurance, "insurance_popup");
}

export function insuranceRemoved(insurance) {
	pushCartEvent("remove_from_cart", insurance, "insurance_popup");
}

export function prepareConfigServiceItem(option) {
	return {
		item_name: option.name,
		item_id: option.id,
		price: option.price,
		quantity: 1,

		item_group_name: "Config Service",
		item_list_id: "recs_popup",

		item_category: "Services",
		item_category2: "Config Service",
	};
}

export function configServiceAdded(configService) {
	pushCartEvent("add_to_cart", configService);
}
